import classNames from "classnames";
import React from "react";
import styles from "./note.css";

interface Props {
  /** with --colorProperty defined */
  className: string;
}
export const Note = ({ className, children }: React.PropsWithChildren<Props>) => {
  return <div className={classNames(styles.container, className)}>{children}</div>;
};
